
import React from "react";
import { motion } from "framer-motion";
import "./Bio.css"; 

function Bio() {
  return (
    <motion.div
      className="bio-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="bio-box">
        <p className="bio-text">
          Javier Cobalto, nace en Estella en 1999 y actualmente reside en España.
          Es licenciado en Bellas Artes por la Universidad del País Vasco (2023) y ha completado un
          Máster en Mercado del Arte y Gestión de Empresas Relacionadas por la Universidad de Nebrija (2024).
          Su trayectoria profesional comienza en 2020, mientras aún cursaba sus estudios, cuando comienza
          a producir obra profesional mediante ilustraciones ejecutadas exclusivamente con bolígrafo Bic de tinta
          azul, estableciendo un lenguaje y un universo únicos, tanto en contenido como en forma.
          Su obra abarca destrezas como la pintura, la ilustración digital, la escultura y el dibujo todos articulados
          en torno a experiencias emocionales, sentimentales y vitales propias, y desarrollando una historia
          argumental distintiva en el Universo Cobalto.
          Sus piezas están interconectadas a través de una simbología y una narrativa comunes en las que obras se
          representan dentro de otras, creando un diálogo constante sobre temas como las relaciones humanas, la crítica
          al sistema, el código moral, las experiencias traumáticas, las deslealtades y las violencias intrínsecas al
          capitalismo y el sufrimiento humano y animal que estas provocan. Su producción reivindica una existencia digna,
          la importancia de una educación artística de calidad, y subraya la relevancia de la ética y los valores humanos en el arte.
          Sostiene que, aunque el arte no transforma el mundo directamente, fomenta y enciende ambientes propicios para la
          reivindicación, actuando como una herramienta de subversión en la búsqueda de modelos de convivencia humana dignos.
          La pintura ocupa un lugar central en su producción y se encuentra en constante evolución.
          Actualmente continúa definiendo sus paradigmas representativos y la dirección técnica y creativa de su obra.
        </p>
      </div>
    </motion.div>
  );
}

export default Bio;